module.exports = __webpack_public_path__ + "img/post-image.24251ad9.png";